import React from "react";
import Swal from "sweetalert2";
import type { SweetAlertIcon } from "sweetalert2";
import { dialogTheme } from "../ui";

const { confirmButtonColor: DEFAULT_CONFIRM_COLOR, cancelButtonColor: DEFAULT_CANCEL_COLOR } =
  dialogTheme();

export interface CustomAlertProps {
  title: string;
  text?: string;
  icon?: SweetAlertIcon;
  confirmButtonText?: string;
  confirmButtonColor?: string;
  onConfirm?: () => void;
  showCancelButton?: boolean;
  cancelButtonText?: string;
  cancelButtonColor?: string;
  onCancel?: () => void;
  onClose?: () => void;
}

const CustomAlert: React.FC<CustomAlertProps> = ({
  title,
  text,
  icon,
  confirmButtonText = "Aceptar",
  confirmButtonColor = DEFAULT_CONFIRM_COLOR,
  onConfirm,
  showCancelButton = false,
  cancelButtonText = "Cancelar",
  cancelButtonColor = DEFAULT_CANCEL_COLOR,
  onCancel,
  onClose,
}) => {
  const handlersRef = React.useRef({ onConfirm, onCancel, onClose });
  handlersRef.current = { onConfirm, onCancel, onClose };

  React.useEffect(() => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText,
      confirmButtonColor,
      showCancelButton,
      cancelButtonText,
      cancelButtonColor,
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      const handlers = handlersRef.current;
      if (result.isConfirmed && handlers.onConfirm) {
        handlers.onConfirm();
      } else if (result.isDismissed && handlers.onCancel) {
        handlers.onCancel();
      }
      handlers.onClose?.();
    });
  }, [title, text, icon, showCancelButton, confirmButtonText, cancelButtonText]);

  return null;
};

export const resetAlert = (): CustomAlertProps => {
  return {
    title: "",
    text: "",
    icon: undefined,
    confirmButtonText: "Aceptar",
    confirmButtonColor: DEFAULT_CONFIRM_COLOR,
    onConfirm: undefined,
    showCancelButton: false,
    cancelButtonText: "Cancelar",
    cancelButtonColor: DEFAULT_CANCEL_COLOR,
    onCancel: undefined,
    onClose: undefined,
  };
};

export default CustomAlert;
